//src/api/account.js
import request from '@/utils/request'

export default {
    get(id) {
        return request.get('/additional/' + id)
    },
    page(page, size, { userId, transactionNo, state, startDate, endDate }) {
        return request.get('/additional', { 
            params: { 
                "pageNo": page, 
                "pageSize": size, 
                "userId": userId,
                "transactionNo": transactionNo,
                "state": state,
                "startDate": startDate, 
                "endDate": endDate 
            } 
        });
    },
    apply(data) {
        return request.post('/additional', data);
    },
    approve(id, params) {
        return request.put('/additional/' + id + '/approve', params);
    },
    undo(id) {
        return request.put('/additional/' + id + '/undo');
    }
}